import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ProcurementTypeRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    procurementType: string;

    @ApiProperty()
    @IsOptional()
    updatedUser: string | null;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;
}